import styled from 'styled-components';

import { media } from 'helpers/breakpoints';
import type { ViewType } from '../../../../../components/SearchPage/SearchPage.typed'; // update

const List = styled.ul<{ viewType: ViewType }>`
  display: grid;
  grid-template-columns: ${({ viewType }) =>
    viewType === 'list' ? '1fr' : 'repeat(2, 1fr)'};
  grid-gap: ${({ theme }) => theme.spacing.S8};

  ${media.medium} {
    grid-gap: ${({ theme }) => theme.spacing.M16};
    grid-template-columns: ${({ viewType }) =>
      viewType === 'list' ? '1fr' : 'repeat(3, 1fr)'};
  }
`;

const CardListItem = styled.li`
  cursor: pointer;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  box-shadow: ${({ theme }) => theme.shadow.CONTAINER};
  overflow: hidden;
`;

export { List, CardListItem };
